"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dta(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.3472 10.884H18.3622L18.375 14.6085L9.99225 19.5L7.74825 18.2385V18.24L7.734 18.231L5.625 16.8787V7.113L7.92975 5.75325L7.93425 5.7555L9.969 4.5L18.3315 9.42225L18.3472 10.884ZM15.891 13.218L14.1368 12.2137L8.2815 15.6593L10.0005 16.6815L15.891 13.218ZM13.7415 11.988L10.1295 9.9195L10.1137 14.1803L13.7415 11.988ZM10.131 9.4635L15.9375 12.8617V10.833L10.1385 7.44675L10.131 9.4635ZM7.74 17.6775L7.7625 15.6427L7.749 15.651V8.472L5.98875 7.422V16.632L7.74 17.6775ZM8.052 15.4268L9.81075 14.3632V7.422L8.052 8.47275V15.4268ZM10.2127 16.95L10.1775 19.077L18.0045 14.475L18.027 12.36L10.2127 16.95ZM16.0575 10.512L17.8793 9.4725L10.038 4.89375L8.2335 5.93775L16.0575 10.512Z", fill: color }));
}
exports["default"] = dta;
//# sourceMappingURL=dta.js.map